import { Box, ButtonBase } from "@mui/material";
import { CalendarMonth, BarChart } from "@mui/icons-material";
import { useThemeContext } from "../../../contexts/ThemeContext";

interface DashboardFiltroToggleProps {
    value: 'ano' | 'data';
    onChange: (value: 'ano' | 'data') => void;
}

export const DashboardFiltroToggle: React.FC<DashboardFiltroToggleProps> = ({ value, onChange }) => {
    const { themeName } = useThemeContext();
    const isDark = themeName === 'dark';

    const opcoes: { value: 'ano' | 'data'; label: string; Icon: React.ElementType }[] = [
        { value: 'ano', label: 'Ano', Icon: BarChart },
        { value: 'data', label: 'Data', Icon: CalendarMonth },
    ];

    return (
        <Box
            sx={{
                backgroundColor: isDark ? 'grey.800' : 'grey.100',
                p: 0.5,
                borderRadius: 3,
                display: 'flex',
                gap: 0.5,
            }}
        >
            {opcoes.map((opcao) => {
                const isSelected = value === opcao.value;
                const { Icon } = opcao;
                return (
                    <ButtonBase
                        key={opcao.value}
                        onClick={() => onChange(opcao.value)}
                        sx={{
                            flex: 1,
                            py: 1,
                            px: 2,
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 0.75,
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            transition: 'all 0.2s ease',
                            ...(isSelected
                                ? {
                                    backgroundColor: isDark ? 'grey.700' : 'background.paper',
                                    color: isDark ? 'common.white' : 'text.primary',
                                    boxShadow: 1,
                                }
                                : {
                                    backgroundColor: 'transparent',
                                    color: 'text.secondary',
                                    '&:hover': {
                                        backgroundColor: isDark
                                            ? 'rgba(255,255,255,0.08)'
                                            : 'rgba(255,255,255,0.5)',
                                    },
                                }),
                        }}
                    >
                        <Icon sx={{ fontSize: 16 }} />
                        {opcao.label}
                    </ButtonBase>
                );
            })}
        </Box>
    );
};
